import React from 'react'
import axios from 'axios'
import { Filter } from '@softwaredev_cegeka/stix-filter'
import { DataTable } from '@softwaredev_cegeka/stix-data-table'
import {
    Icon,
    Button,
    Pagination,
    Grid,
    Alert,
} from '@softwaredev_cegeka/stix-core'
import { Modal } from '@softwaredev_cegeka/stix-modal'
import { SelectPicker } from '@softwaredev_cegeka/stix-form-select'
import { Label } from '@softwaredev_cegeka/stix-form'
import { notifierStore } from 'src/stores'

class AddUsersToGroupTable extends React.Component {
    PER_PAGE = 6
    constructor(props) {
        super(props)
        this.state = {
            filteredData: props.data || [],
            filters: {},
            globalSearch: '',
            selectedRows: [],
            currentPage: 1,
            lastPage: 1,
            showAddModal: false,
            groups: [],
            selectedGroups: [],
        }
    }

    componentDidMount() {
        this.loadGroups()
    }

    loadGroups = () => {
        const { organizationId } = this.props
        if (!organizationId) return
        axios
            .get(`/api/auth/tenants/${organizationId}/groups`, {
                params: {
                    per_page: 1000,
                    load_relationships: true,
                },
            })
            .then(result => {
                this.setState({
                    groups: result.data?.results?.map(group => ({
                        value: `${group.name} (${group.tenant.name})`,
                        label: `${group.name} (${group.tenant.name})`,
                        id: group.id,
                        name: group.name,
                    })),
                })
            })
            .catch(err => {
                console.warn('Failed to fetch groups: ', err)
                this.setState({ groups: [] })
            })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.organizationId !== this.props.organizationId) {
            this.loadGroups()
        }
        if (
            prevProps.data.length !== this.props.data.length ||
            this.props.data.some(
                (item, index) => item !== prevProps.data[index]
            )
        ) {
            let filteredData = this.props.data
            if (this.state.filters)
                filteredData = this.applyFilters(
                    filteredData,
                    this.state.filters
                )
            if (this.state.globalSearch) {
                filteredData = this.applyGlobalSearch(
                    filteredData,
                    this.state.globalSearch
                )
            }
            this.setState({
                filteredData,
                currentPage: 1,
                lastPage: Math.ceil(filteredData.length / this.PER_PAGE),
            })
        }
    }

    getColumns() {
        return [
            {
                Header: () => {
                    const { selectedRows, filteredData } = this.state
                    const allSelected =
                        filteredData.length !== 0 &&
                        selectedRows.length === filteredData.length
                    return (
                        <input
                            type="checkbox"
                            checked={allSelected}
                            onChange={() =>
                                allSelected
                                    ? this.setState({
                                          selectedRows: [],
                                      })
                                    : this.setState({
                                          selectedRows: filteredData,
                                      })
                            }
                        />
                    )
                },
                accessor: 'selector',
                Cell: selectedRow => {
                    const { selectedRows } = this.state
                    const user = selectedRow.row.original
                    const isSelected = selectedRows.includes(user)
                    return (
                        <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => {
                                isSelected
                                    ? this.setState({
                                          selectedRows: selectedRows.filter(
                                              obj => obj.email !== user.email
                                          ),
                                      })
                                    : this.setState({
                                          selectedRows: [...selectedRows, user],
                                      })
                            }}
                        />
                    )
                },
                width: '5%',
            },
            {
                Header: 'First name',
                accessor: 'first_name',
                width: '10%',
            },
            {
                Header: 'Last name',
                accessor: 'last_name',
                width: '10%',
            },
            {
                Header: 'Email',
                accessor: 'email',
                width: '30%',
            },
            {
                Header: 'Groups',
                accessor: 'groups',
                width: '40%',
                Cell: ({ cell }) =>
                    cell.row.original.groups
                        ?.map(item => item.name)
                        .join(', ') || '-',
            },
            {
                Header: 'Added to group',
                accessor: 'hasGroups',
                Cell: ({ cell }) => {
                    return cell.row.original.groups?.length ? (
                        <Icon icon={'success'} />
                    ) : (
                        ''
                    )
                },
                width: '5%',
            },
        ]
    }

    getFilters() {
        return [
            {
                field: 'hasGroups',
                label: 'Added to group',
                options: ['Yes', 'No'],
            },
            {
                field: 'first_name',
                label: 'First name',
            },
            {
                field: 'last_name',
                label: 'Last name',
            },
            {
                field: 'email',
                label: 'Email',
            },
        ]
    }

    applyFilters = (data, filters) => {
        let filteredData = [...data]
        Object.entries(filters).forEach(([key, value]) => {
            if (key === 'hasGroups') {
                if (value === 'YES')
                    filteredData = filteredData.filter(
                        item => item.groups?.length
                    )
                else
                    filteredData = filteredData.filter(
                        item => !item.groups?.length
                    )
            } else {
                filteredData = filteredData.filter(item =>
                    item[key].toLowerCase().includes(value.toLowerCase())
                )
            }
        })
        return filteredData
    }

    applyGlobalSearch = (data, search) => {
        if (!search) return data
        search = search.toLowerCase()
        const searchableColumns = ['first_name', 'last_name', 'email']
        let filteredData = data.filter(item => {
            let shouldBeIncluded = false
            searchableColumns.forEach(column => {
                if (item[column].toLowerCase().includes(search))
                    shouldBeIncluded = true
            })
            return shouldBeIncluded
        })
        return filteredData
    }

    handleFilterChange = values => {
        const { data } = this.props
        let filteredData = this.applyFilters(data, values)
        if (this.state.globalSearch)
            filteredData = this.applyGlobalSearch(
                filteredData,
                this.state.globalSearch
            )

        this.setState({ filteredData, filters: values })
    }

    handleChangeGlobalFilter = value => {
        const { data } = this.props
        let filteredData = this.applyGlobalSearch(data, value)
        if (this.state.filters) {
            filteredData = this.applyFilters(filteredData, this.state.filters)
        }

        this.setState({ filteredData, globalSearch: value })
    }

    renderUserOption = user => {
        return (
            <div style={{ display: 'flex' }}>
                <div>
                    <div>{user.label}</div>
                    <small>{user.value}</small>
                </div>
                <Button
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: 10,
                        transform: 'translateY(-50%)',
                        padding: 0,
                    }}
                    variant="naked"
                    onClick={() =>
                        this.setState({
                            selectedRows: this.state.selectedRows.filter(
                                item => item.email !== user.value
                            ),
                        })
                    }
                >
                    <Icon icon="delete" />
                </Button>
            </div>
        )
    }

    renderGroupOption = group => {
        const { selectedGroups } = this.state
        const isSelected = selectedGroups.includes(group)
        return (
            <div>
                <input
                    type={'checkbox'}
                    checked={isSelected}
                    onChange={() =>
                        isSelected
                            ? this.setState({
                                  selectedGroups: selectedGroups.filter(
                                      item => item.id !== group.id
                                  ),
                              })
                            : this.setState({
                                  selectedGroups: [...selectedGroups, group],
                              })
                    }
                />
                <span style={{ paddingLeft: '0.5rem' }}>{group.label}</span>
            </div>
        )
    }

    handleAddUserToGroup = () => {
        const { selectedGroups } = this.state
        const updatedRows = this.state.selectedRows.map(user => ({
            ...user,
            groups: [...user.groups, ...selectedGroups],
        }))

        this.props.onUpdateUsers(updatedRows)
        this.setState(
            {
                selectedRows: [],
                selectedGroups: [],
                showAddModal: false,
            },
            () => {
                notifierStore.setToastInfo(
                    `User(s) successfully marked for adding to group(s): ${selectedGroups
                        .map(group => group.name)
                        .join(', ')}`,
                    true
                )
                notifierStore.setShowMessage(true)
            }
        )
    }

    renderModal = () => {
        return (
            <Modal show={this.state.showAddModal} centered size="md">
                <Modal.Header>
                    <Modal.Title>
                        <span className="ml-2">Add selection to group(s)</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Label label={'Selected users'} />
                    <SelectPicker
                        options={this.state.selectedRows.map(item => ({
                            value: item.email,
                            label: `${item.first_name} ${item.last_name}`,
                            id: item.email,
                            item: item,
                        }))}
                        isOptionDisabled={() => true}
                        getOptionLabel={this.renderUserOption}
                    />
                    <Label label={'Groups'} />
                    <SelectPicker
                        options={this.state.groups}
                        isOptionDisabled={() => true}
                        getOptionLabel={this.renderGroupOption}
                    />
                </Modal.Body>
                <Modal.Footer align={'left'}>
                    <Button
                        variant="secondary"
                        onClick={this.handleAddUserToGroup}
                    >
                        Add
                    </Button>
                    <Button
                        variant="link"
                        onClick={() => {
                            this.setState({
                                showAddModal: false,
                                selectedGroups: [],
                            })
                        }}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    render() {
        return (
            <>
                {this.renderModal()}
                <Grid.Row>
                    <Grid.Col md={{ span: 6, offset: 3 }}>
                        {this.props.data.some(
                            user => user.groups.length === 0
                        ) && (
                            <Alert variant={'secondary'}>
                                All users must be part of at least one group.
                            </Alert>
                        )}
                    </Grid.Col>
                </Grid.Row>

                <DataTable
                    columns={this.getColumns()}
                    data={this.state.filteredData.slice(
                        this.PER_PAGE * (this.state.currentPage - 1),
                        this.PER_PAGE * this.state.currentPage
                    )}
                    variant={'compact'}
                    headerComponent={
                        <Filter
                            filters={this.getFilters()}
                            onFilterChange={this.handleFilterChange}
                            onChangeGlobalFilter={this.handleChangeGlobalFilter}
                        />
                    }
                />
                <Pagination
                    lastPage={this.state.lastPage}
                    currentPage={this.state.currentPage}
                    onClick={currentPage => this.setState({ currentPage })}
                />
                <Button
                    block
                    variant="outline-secondary"
                    disabled={this.state.selectedRows.length === 0}
                    onClick={() =>
                        this.setState({
                            showAddModal: !this.state.showAddModal,
                        })
                    }
                >
                    <Icon icon={'add'} title={'ADD SELECTION TO GROUP(S)'} />
                </Button>
            </>
        )
    }
}

export default AddUsersToGroupTable
